<ng-container *ngIf="!loading">
  <div class="p-fluid">
    <div class="field">
      <label class="font-medium required-field">Метод</label>
      <crm-input-text [(value)]="form.method"></crm-input-text>
    </div>

    <div class="field">
      <label class="font-medium">Параметры</label>
      <textarea
        pInputTextarea
        [(ngModel)]="form.params"
        rows="5"
        [autoResize]="false"></textarea>
    </div>

    <div
      *ngIf="result?.length"
      class="field">
      <label class="font-medium">Ответ</label>

      <textarea
        pInputTextarea
        [(ngModel)]="result"
        rows="5"
        [disabled]="true"
        [autoResize]="false"></textarea>
    </div>
  </div>

  <div class="flex align-items-center justify-content-between gap-3">
    <button
      pButton
      label="Отправить"
      class="p-button-success"
      [disabled]="!form.method?.length"
      (click)="send()"></button>

    <button
      pButton
      type="button"
      icon="pi pi-copy"
      label="Скопировать ответ"
      class="p-button-warning p-button-text"
      (click)="copyResult()"></button>

    <button
      *ngIf="result?.length"
      pButton
      label="Очистить"
      icon="pi pi-undo"
      class="p-button-text p-button-secondary"
      (click)="result = ''"></button>
  </div>
</ng-container>

<crm-spinner *ngIf="loading"></crm-spinner>
